import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { AppstoreOutlined } from '@ant-design/icons';
import Modules from "./index";
import ViewModule from "./view";
import EditModule from "./edit";
import { MODULE_MODULES } from "variables/constants";

const modulesRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Modules",
		basePath: "modules",
		mainComponent: <Modules />,
	    layout: "/console",	   
	    icon: <AppstoreOutlined className="h-6 w-6" />,
	    subTitle:"Module",
	    viewComponent: <ViewModule />,
	    createComponent: <EditModule />,
	    editComponent: <EditModule />,
		level: 1,
		moduleId: MODULE_MODULES,
	})
]

export default modulesRoutes;